
<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div id="Notifications">
    <!-- <h2 class="text-primary mb-2 font-40px">{{ $t("notifications") }}</h2> -->

<!--    <div-->
<!--      v-if="dashboardNotificationLoader"-->
<!--      class="d-flex align-items-center justify-content-center fixed-h"-->
<!--    >-->
<!--      <b-spinner variant="primary" type="grow" label="Spinning"></b-spinner>-->
<!--    </div>-->
    <page-loader v-if="dashboardNotificationLoader"></page-loader>
    <div class="giga-notifications_section">
      <b-tabs v-if="!dashboardNotificationLoader">
        <b-tab active>
          <template #title> Importantes </template>
          <!-- MAX 4 NOTIFCATIONS PER ROW -->
          <div class="giga-notifications_list" :id="importantNotifs">
            <collapse-notification
                v-for="(notification, index) in importantNotifications.slice(
                (rolePagedFilter.myPager.page - 1) * rolePagedFilter.myPager.size,
                (rolePagedFilter.myPager.page - 1) * rolePagedFilter.myPager.size + rolePagedFilter.myPager.size
              )"
                :key="index"
                :notification="notification"
                :id="'colpase-' + index"
                visible
                :noTitlePrimary="true"
                :redirection="true"
                :allImportant="true"
                @markNotificationAsRead="markNotificationAsRead"
            ></collapse-notification>
          </div>

          <pagination
              :length="length"
              :rows="importantNotifsRow"
              :perPage="rolePagedFilter.myPager.size"
              :ariaControls="importantNotifs"
              :currentPage="rolePagedFilter.myPager.page"
              v-on:changePerPage="changeRolePerPage($event)"
              v-on:changeCurrentPage="changeRoleCurrentPage($event)"
          >
          </pagination>
        </b-tab>
        <b-tab>
          <template #title> Toutes les notifications </template>
          <!-- MAX 4 NOTIFCATIONS PER ROW -->
          <div class="giga-notifications_list" id="allNotifications">
            <collapse-notification
              v-for="(notification, index) in notifications.slice(
                (rolePagedFilter.myPager.page - 1) * rolePagedFilter.myPager.size,
                (rolePagedFilter.myPager.page - 1) * rolePagedFilter.myPager.size + rolePagedFilter.myPager.size
              )"
              :key="index"
              :notification="notification"
              :id="'colpase-' + index"
              visible
              :noTitlePrimary="true"
              :redirection="true"
              :allImportant="false"
              @markNotificationAsRead="markNotificationAsRead"
            ></collapse-notification>
          </div>

          <pagination
            :length="length"
            :rows="notifsRow"
            :perPage="rolePagedFilter.myPager.size"
            :ariaControls="importantNotifs"
            :currentPage="rolePagedFilter.myPager.page"
            v-on:changePerPage="changeRolePerPage($event)"
            v-on:changeCurrentPage="changeRoleCurrentPage($event)"
          >
          </pagination>
        </b-tab>
      </b-tabs>
    </div>

    <!--<b-row align-v="stretch">
      <b-col cols="12" md="6" class="mb-4">
        <b-card
          class="h-100 card-grid border-raduis-xl"
          style="min-height: 338px"
          body-class="h-100"
        >
          <div
            class="h-100 d-flex flex-column align-items-center justify-content-center"
          >
            <h2 class="text-primary">{{ $t("works") }}</h2>
            <span class="font-weight-light">{{
              $t("consult_your_current_works")
            }}</span>
            <b-button
              :to="{ name: 'Works' }"
              size="lg"
              pill
              variant="primary"
              class="px-4 mt-4 d-flex align-items-center text-nowrap"
              >{{ $t("Work_in_progress") }}</b-button
            >
          </div>
        </b-card>
      </b-col>
      <b-col cols="12" md="6" class="mb-4">
        <b-card
          class="h-100 card-grid border-raduis-xl"
          style="min-height: 338px"
          body-class="h-100"
        >
          <div
            class="h-100 d-flex flex-column align-items-center justify-content-center"
          >
            <h2 class="text-primary">{{ $t("simulations") }}</h2>
            <div class="d-inline-flex justify-content-center flex-wrap">
              <b-button
                :to="{ name: 'Simulations' }"
                 size="lg"
                pill
                variant="outline-primary"
                class="px-4 mt-4 mx-2 d-inline-flex align-items-center text-nowrap"
                >{{ $t("simulations_in_progress") }}</b-button
              >
              <b-button
                :to="{ name: 'AddSimulation' }"
                 size="lg"
                pill
                variant="primary"
                class="px-4 mt-4 mx-2 d-inline-flex align-items-center text-nowrap"
                ><b-icon icon="circle-fill" class="mr-2"></b-icon
                >{{ $t("new_simulation") }}</b-button
              >
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>-->
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import CollapseNotification from "../components/static/CollapseNotification.vue";
import {notificationService} from "./service/notification.service";
import Pagination from "@/components/static/Pagination";
import PageLoader from "../components/static/pageLoader";

export default {
  name: "Notifications",
  components: { CollapseNotification, Pagination, PageLoader },
  data() {
    const _pageSize_10 = 5;
    const _pageSize_25 = 7;
    const _pageSize_50 = 10;

    return {
      length: [_pageSize_10, _pageSize_25, _pageSize_50],
      importantNotifs: "important-Notifs",
      rolePagedFilter: {
        myPager: {
          page: 1,
          size: 4,
        },
        search: "",
        // customFilter: queryConstant.setDefaultCustomFilter(),
      },
    };
  },
  mounted() {
    this.getDashboardNotificationsAction();
    this.getDashboardImportantNotificationsAction();
    if (!this.sidebarShowStatus) {
      this.setSidebarShow(true);
      this.toggleSidebar();
    }
  },
  computed: {
    ...mapGetters("notification", {
      notifications: "getDashboardNotifications",
      importantNotifications: "getDashboardImportantNotifications"
    }),
    ...mapGetters("loader", {
      dashboardNotificationLoader: "getDashboardNotificationLoader",
    }),
    ...mapGetters("leftsidebar", { sidebarShowStatus: "getSidebarShowStatus" }),
    importantNotifsRow() {
      return this.importantNotifications.length;
    },
    notifsRow() {
      return this.notifications.length;
    }
  },
  methods: {
    ...mapActions("notification", ["getDashboardNotificationsAction", "getDashboardImportantNotificationsAction"]),
    ...mapMutations({
      toggleSidebar: "leftsidebar/toggleSidebar",
      setSidebarShow: "leftsidebar/setSidebarShow",
    }),
    markNotificationAsRead(notificationId) {
      notificationService.markNotificationsAsRead([notificationId], true);
    },
    changeRolePerPage(perPage) {
      this.rolePagedFilter.myPager.page = 1;
      this.rolePagedFilter.myPager.size = perPage;
    },
    changeRoleCurrentPage(currentPage) {
      this.rolePagedFilter.myPager.page = currentPage;
    },
  },
};
</script>
<style lang='scss' scoped>
.fixed-h {
  min-height: 60px;
  max-height: 60px;
}
</style>
